import React, { useState } from "react";
import { useToast } from "../hooks/use-toast";

const BulletinForm = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    accept: false,
  });

  const handle = (k, v) => setForm({ ...form, [k]: v });

  const submit = (e) => {
    e.preventDefault();
    if (!form.firstName || !form.lastName || !form.phone || !form.email) {
      toast({ title: "Eksik bilgi", description: "Lütfen tüm alanları doldurun." });
      return;
    }
    if (!form.accept) {
      toast({ title: "Onay gerekli", description: "Lütfen KVKK metnini onaylayın." });
      return;
    }
    toast({
      title: "Talebiniz alındı",
      description: "Bültenlerimiz e-mail adresinize gönderilecek.",
    });
    setForm({ firstName: "", lastName: "", phone: "", email: "", accept: false });
  };

  return (
    <section
      className="relative"
      style={{
        background:
          "linear-gradient(180deg, #1c4d9c 0%, #143a78 100%)",
      }}
    >
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path d='M20 80 L40 20 L60 80' fill='none' stroke='white' stroke-width='3'/><circle cx='80' cy='30' r='4' fill='white'/></svg>\")",
          backgroundSize: "180px",
        }}
      />
      <div className="relative max-w-[1280px] mx-auto px-4 py-16 grid lg:grid-cols-2 gap-12 items-center text-white">
        <div>
          <h2 className="text-4xl md:text-5xl font-bold mb-5">Bülten Talep</h2>
          <p className="text-white/90 leading-relaxed max-w-xl">
            Tecrübeli araştırma kadromuzun hergun hazırladığı raporlara ulaşmak
            için yandaki formu doldurabilirsiniz. Kaydı eksiksiz doldurmanız
            halinde bültenlerimiz e-mail adresinize her gün düzenli olarak
            gönderilecektir.
          </p>
        </div>

        <form
          onSubmit={submit}
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          <input
            type="text"
            placeholder="Adınız"
            value={form.firstName}
            onChange={(e) => handle("firstName", e.target.value)}
            className="col-span-1 bg-transparent border border-white/40 rounded-md px-4 py-3 text-white placeholder-white/70 focus:border-white transition"
          />
          <input
            type="text"
            placeholder="Soyadınız"
            value={form.lastName}
            onChange={(e) => handle("lastName", e.target.value)}
            className="col-span-1 bg-transparent border border-white/40 rounded-md px-4 py-3 text-white placeholder-white/70 focus:border-white transition"
          />
          <input
            type="tel"
            placeholder="Telefon Numaranız (XXX) XXX XX XX"
            value={form.phone}
            onChange={(e) => handle("phone", e.target.value)}
            className="col-span-1 bg-transparent border border-white/40 rounded-md px-4 py-3 text-white placeholder-white/70 focus:border-white transition"
          />
          <input
            type="email"
            placeholder="E-Mail Adresiniz"
            value={form.email}
            onChange={(e) => handle("email", e.target.value)}
            className="col-span-1 bg-transparent border border-white/40 rounded-md px-4 py-3 text-white placeholder-white/70 focus:border-white transition"
          />
          <label className="col-span-1 md:col-span-2 flex items-start gap-2 text-[13px] text-white/90">
            <input
              type="checkbox"
              checked={form.accept}
              onChange={(e) => handle("accept", e.target.checked)}
              className="mt-1 accent-white"
            />
            <span>
              Kişisel Verilerin Korunması Kanunu hakkında{" "}
              <a href="/kisisel-verilerin-korunmasi" className="underline font-medium">
                bilgilendirmeyi
              </a>{" "}
              okudum, kabul ediyorum.
            </span>
          </label>
          <button
            type="submit"
            className="col-span-1 md:col-span-2 bg-[#2b2b35] hover:bg-black text-white font-semibold py-3 rounded-md transition"
          >
            Gönder
          </button>
        </form>
      </div>
    </section>
  );
};

export default BulletinForm;
